<template>
    <div v-if="show" class="ft-modal">
        <FtMask :mask-click="onMaskClick" :prevent-stop-move="preventStopMove">
            <div class="ft-modal-content">
                <div class="ft-modal-content-body">
                    <slot></slot>
                </div>
                <div class="ft-modal-close-row" v-if="onClose">
                    <a @click="onClose" class="ft-modal-close"></a>
                </div>
            </div>
        </FtMask>
    </div>
</template>

<script>
import FtMask from './Mask.vue';
export default {
    props: ['onClose', 'show', 'onMaskClick', 'preventStopMove'],
    components: {
        FtMask
    }
};
</script>

<style lang="less">
.ft-modal {
    &-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        &-body {
            position: relative;
        }
    }
    &-close {
        color: red;
        display: block;
        width: 0.48rem;
        height: 0.48rem;
        background: url(./close.svg) no-repeat;
        background-size: 100% 100%;
        &-row {
            display: inline-block;
            padding-top: 0.6rem;
            height: 1.08rem;
        }
    }
}
</style>
